"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateHelper = exports.DEFAULT_DATE_FORMAT = void 0;
const date_fns_1 = require("date-fns");
exports.DEFAULT_DATE_FORMAT = 'yyyy-MM-dd';
class DateHelper {
    constructor() {
        this.coerceToDate = (date) => {
            if (!date) {
                return new Date(0);
            }
            else if (typeof date === 'string' || typeof date === 'number') {
                return new Date(date);
            }
            return date;
        };
    }
    getFormattedDate(date, dateFormat = exports.DEFAULT_DATE_FORMAT) {
        return (0, date_fns_1.format)(this.coerceToDate(date), dateFormat);
    }
    // mostly used with DatePicker to avoid timezone issue
    addTimePart(dateStr) {
        return dateStr + 'T00:00:00';
    }
}
exports.dateHelper = new DateHelper();
//# sourceMappingURL=date-helper.js.map